import React from "react";
import { useForm } from "react-hook-form";
import { Modal } from "react-bootstrap";
import { toast, Slide } from "react-toastify";
import CryptoJS from "crypto-js";
import axios from "axios";
import authHeader from "../../../services/auth.header";
import { API_URL } from "../../../utilities/url";
import storage from "../../../services/storage";
import authService from "../../../services/auth.service";

const AddDeviceGroupModal = ({ show, handleClose, onChangeData }) => {
  const decryptUSR = CryptoJS.AES.decrypt(storage.get("user"), "user").toString(
    CryptoJS.enc.Utf8
  );
  const dt_user = JSON.parse(decryptUSR);
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);

  // useForm untuk modal, dengan `shouldUnregister: true`
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    shouldUnregister: true, // Hanya validasi saat modal terbuka
  });

  // Fungsi submit form di modal
  const addContactGroup = (data) => {
    axios
      .post(
        API_URL + "add-device-group",
        {
          idt_user: dt_user.idt_user,
          idt_user_workspace: workspace.idt_user_workspace,
          name: data.device_group_add,
          description: data.description,
        },
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          toast.success("Add Group Device Successful", {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          });
          onChangeData();
        } else {
          toast.error("Add Group Device Failed", {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          });
        }
        handleClose();
        reset();
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        } else {
          handleClose();
        }
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Device Group</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(addContactGroup)}>
          <div className="row">
            <div className="col-md-12">
              <div className="mb-3 row">
                <label className="col-form-label col-sm-4 text-sm-right">
                  Device Group Name
                  <span className="required">*</span>
                </label>
                <div className="col-sm-8 error-placeholder">
                  <input
                    type="text"
                    {...register("device_group_add", {
                      required: "Device Group Name is required",
                    })}
                    className={`form-control ${
                      errors.device_group_add ? "is-invalid" : ""
                    }`}
                    placeholder="Device Group Name"
                  />
                  {errors.device_group_add && (
                    <div className="invalid-feedback">
                      {errors.device_group_add.message}
                    </div>
                  )}
                </div>
              </div>

              {/* Description */}
              <div className="mb-3 row">
                <label className="col-form-label col-sm-4 text-sm-right">
                  Description
                </label>
                <div className="col-sm-8 error-placeholder">
                  <textarea
                    rows={5}
                    {...register("description")}
                    className="form-control"
                    placeholder="Description"
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <div className="col-sm-12 text-end">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddDeviceGroupModal;
